import { AccountService } from '@services/account/account.service';
import { Component, OnDestroy, OnInit } from '@angular/core';

import * as AuthReducer from '@store/auth/reducers';
import {Store} from '@ngrx/store';
import {SignOut, UpdateAuthUser} from '@store/auth/actions';
import {AuthFacade} from '@app/facades/auth/authFacade';
import {MatDialog} from '@angular/material';
import {CreateSchoolComponent} from '@pages/layout/school/create-school/create-school.component';
import * as ProgramReducer from '@store/program/reducers';
import {RemoveAllPrograms, SetPrograms} from '@store/program/actions';
import {NavigationEnd, Router} from '@node_modules/@angular/router';
import {SetStudents} from '@store/student/actions';
import {User} from '@models/user';
import {StudentService} from '@services/student/student.service';
import * as StudentReducer from '@store/student/reducers';
import {TeacherService} from '@services/teacher/teacher.service';
import * as TeacherReducer from '@store/teacher/reducers';
import * as SubscriptionReducer from '@store/subscription/reducers';
import {SetTeachers} from '@store/teacher/actions';
import {ProgramService} from '@services/program/program.service';
import {Program} from '@models/program';
import {PusherService} from '@services/pusher/pusher.service';
import {Curriculum} from '@models/curriculum';
import {SubscriptionState} from '@store/subscription/reducers';
import {UpdateSubscription} from '@store/subscription/actions';
import {Subscription} from '@models/subscription';
import {TermsComponent} from '@components/terms/terms.component';
import {School} from '@models/shool';
import {SchoolService} from '@services/school/school.service';
import {ConfirmModalComponent} from '@components/confirm-modal/confirm-modal.component';
import {PaymentService} from '@services/payment/payment.service';
import {RechargeFailedChargeStudentDialog} from '@components/recharge-failed-charge-student-dialog/recharge-failed-charge-student-dialog.component';
import {AccountServiceResponseInterface} from '@interfaces/accountServiceResponse.interface';
import {PermissionFacade} from '@facades/permission/permissionFacade';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit, OnDestroy {
  email: string;
  name: string;
  avatar: string;
  user: User;
  notAdmin;
  selectedSchool: number;
  currentUrl = '';
  schools = [];
  current_school;

  /**
   * Tracks the last school id actually loaded via loadCurrentSchool() so
   * repeated, unrelated ngrx Store emissions (this component subscribes
   * to the raw Store in ngOnInit and therefore re-runs on every action
   * dispatched anywhere in the app) don't re-issue an identical
   * schoolService.getSchool() request for a school that's already loaded.
   * Reset only implicitly, by a genuinely different selectedSchool value.
   */
  private lastLoadedSchoolId: number = null;

  subsModal: any;
  isSubsModalShown: boolean;

  constructor(
    private route: Router,
    public dialog: MatDialog,
    private authFacade: AuthFacade,
    private authStore: Store<AuthReducer.AuthState>,
    private studentService: StudentService,
    private studentStore: Store<StudentReducer.StudentState>,
    private subscribtionStore: Store<SubscriptionReducer.SubscriptionState>,
    private teacherService: TeacherService,
    private teacherStore: Store<TeacherReducer.TeacherState>,
    private programService: ProgramService,
    private pusherService: PusherService,
    private schoolService: SchoolService,
    private programStore: Store<ProgramReducer.ProgramState>,
    private accountService: AccountService,
    private paymentService: PaymentService
  ) {
    route.events.subscribe((val: NavigationEnd) => {
      let url = val.url;
      if (val.url) {
        url = val.url.split('?')[0];
      }
      this.currentUrl = url;
    });
  }

  showSystemSubscriptionModal(status: any) {
    if (this.isSubsModalShown) {
      return;
    }

    if (status.status === 'subscriptions_fail') {
      this.route.navigate(['/subscriptions']);
    } else {
      this.route.navigate(['/profile']);
    }

    ConfirmModalComponent.textModal = status.message;
    ConfirmModalComponent.textButton = status.button;
    ConfirmModalComponent.withButtons = true;
    ConfirmModalComponent.hideCancel = true;
    ConfirmModalComponent.methodDelete = 'goFromModal';
    ConfirmModalComponent.insertedObject = this;
    this.subsModal = this.dialog.open(ConfirmModalComponent);
    ConfirmModalComponent.modalRef = this.subsModal;
    this.isSubsModalShown = true;
  }

  showStudentRechargeFailedPaymentModal(status) {
    if (this.isSubsModalShown) {
      return;
    }

    RechargeFailedChargeStudentDialog.systemSubscriptionStatus = status;
    this.subsModal = this.dialog.open(RechargeFailedChargeStudentDialog);
    RechargeFailedChargeStudentDialog.modalRef = this.subsModal;
    this.isSubsModalShown = true;
  }

  goFromModal() {
    this.subsModal.close();
  }

  ngOnInit() {
    this.applyDocumentTheme();
    this.accountService
      .getAccount()
      .subscribe(
        (response: AccountServiceResponseInterface) => {
          const permissions = PermissionFacade.groupByModelName(response.data.permissions);
          const user = this.authFacade.createUser(response, permissions);
          this.authFacade.updateSystemSubscriptionStatus(user.systemSubscriptionStatus);

          const status = user.systemSubscriptionStatus && user.systemSubscriptionStatus.length > 0
            ? user.systemSubscriptionStatus[0]
            : null;

          if (status && status.status !== 'active') {
            if (status.charge && status.charge.id) {
              this.showStudentRechargeFailedPaymentModal(status);
            } else {
              this.showSystemSubscriptionModal(status);
            }
          }

        },
        error => {
          console.log('fetch user error', error);
        }
      );

    this.authStore.subscribe(
      (val) => {
        const user = AuthFacade.getUser();
        if (user) {
          this.user = user;
          this.notAdmin = user.notAdmin;
          this.name = user.name;
          this.email = user.email;
          this.avatar = user.avatar;
          this.schools = user.schools ? user.schools : [];
          this.selectedSchool = user.activeSchool ? user.activeSchool : null;
          if (!this.selectedSchool && this.schools && this.schools.length > 0) {
            this.onSelectedSchools(this.schools[0].id);
          }
          if (this.user && !this.user.notAdmin && this.selectedSchool) {
            this.loadCurrentSchool(this.selectedSchool);
          }
        }
      }
    );
    setTimeout(() => {
        if (this.user  && this.selectedSchool) {
            this.loadCurrentSchool(this.selectedSchool);
        }
      this.pusherService.getNewMessages(this.user.id).subscribe(
        (resp: {new_messages: number}) => {
          this.user.not_read_messages = resp.new_messages;
          this.authStore.dispatch(new UpdateAuthUser({not_read_messages : resp.new_messages}))
        }
      );
      this.pusherService.updateSubscritpions(this.user.id).subscribe(
        (resp: {status: number}) => {
          if (resp.status === 1) {
            this.subscribtionStore.dispatch(new UpdateSubscription(new Subscription()));
          }
        });
    });
    const header: HTMLElement = document.getElementsByClassName('header-wrapper')[0] as HTMLElement;
    if (header) {
      this.stickyHeader(header);
      const thisElement = this;
      window.onscroll = function () {
        thisElement.stickyHeader(header);
      };
    }
  }

  isDashboardDarkTheme(): boolean {
    return localStorage.getItem('mkc-dashboard-theme') === 'dark';
  }

  ngOnDestroy() {
    document.documentElement.classList.remove('mkc-dashboard-shell');
    document.documentElement.classList.remove('mkc-theme-dark');
    document.body.classList.remove('mkc-dashboard-shell');
    document.body.classList.remove('mkc-theme-dark');
  }

  private applyDocumentTheme() {
    const isDarkTheme = this.isDashboardDarkTheme();
    document.documentElement.classList.add('mkc-dashboard-shell');
    document.body.classList.add('mkc-dashboard-shell');
    document.documentElement.classList.toggle('mkc-theme-dark', isDarkTheme);
    document.body.classList.toggle('mkc-theme-dark', isDarkTheme);
  }

  stickyHeader(header) {
    if (window.pageYOffset > header.offsetTop) {
      header.classList.add('sticky');
    } else {
      header.classList.remove('sticky');
    }
  }

  onLogout() {
    this.authStore.dispatch(new SignOut(this.authFacade));
    this.programStore.dispatch(new RemoveAllPrograms());
    // document.location.reload();
  }

  /**
   * Loads the given school's data exactly once per distinct schoolId,
   * regardless of how many times it's called (the raw Store subscription
   * in ngOnInit calls this on every unrelated store emission, and the
   * initial setTimeout call can race it on first load - see
   * lastLoadedSchoolId). A genuinely different schoolId still loads
   * correctly, since the guard only blocks a repeat of the SAME id.
   */
  private loadCurrentSchool(schoolId: number) {
    if (!schoolId || schoolId === this.lastLoadedSchoolId) {
      return;
    }

    this.lastLoadedSchoolId = schoolId;
    this.schoolService.getSchool(schoolId).subscribe(
      (resp: {data: School}) => {
        this.current_school = resp.data;
        localStorage.setItem('school', JSON.stringify(resp.data));
      }
    );
  }

  onSelectedSchools(select) {
    const selected = select.value ? select.value : select;
    this.authStore.dispatch(new UpdateAuthUser({activeSchool : selected}));
    this.programStore.dispatch(new RemoveAllPrograms());
    let url = this.route.url;
    // console.log(url);
    switch(url) {
      case '/students':
        this.studentService.getAll()
          .subscribe(
            (resp: {data: User[]}) => {
              this.studentStore.dispatch(new SetStudents(resp.data));
            }
          );
        break;
      case '/teachers':
        this.teacherService.getAll()
          .subscribe(
            (resp: {data: User[]}) => {
              this.teacherStore.dispatch(new SetTeachers(resp.data));
            }
          );
        break;
      case '/program':
        this.programService.getAll()
          .subscribe(
            (resp : {data: [Program]}) => {
              this.programStore.dispatch(new SetPrograms(resp.data));
            }
          );
        break;
      default:
        break;
    }
  }

  isProgramPage() {
    return this.currentUrl === '/program';
  }
  openCreateModal() {
    const dialogRef = this.dialog.open(CreateSchoolComponent);
    dialogRef.afterClosed().subscribe(result => {
      dialogRef.close();
    });
  }
  toProfilePage() {
    this.route.navigate(['/profile']);
  }
  toMessagesPage() {
    this.route.navigate(['/messages']);
  }

  openFooterDialog() {
    const reference = this.dialog.open(TermsComponent);
    TermsComponent.modalRef = reference;
  }
}
